


































import { defineComponent } from '@nuxtjs/composition-api'
import { PropType } from 'vue';
import { useConfig } from '~/composables';
import { temiCaldiLink } from '~/helpers/trackings/24orepro/pages';

export default defineComponent({
    props: {
        classes: {
            type: Object,
            default: () => { return {} }
        },
        title: {
            type: String,
            required: true
        },
        subtitle: {
            type: String
        },
        imageSrc: {
            type: String
        }
    },
    data() {
        return {
            sprite: require('~/assets/solepro/spritemap.svg')
        }
    },
    setup() {
        const { config: storeConfig } = useConfig()
        const trackTemiCaldiLink = () => temiCaldiLink();
        return {
            storeCode: storeConfig.value?.store_code,
            trackTemiCaldiLink
        }
    },
})
